
import sun_rise from '/@/assets/images/weather/sun_rise.png'
import nt_cld from '/@/assets/images/weather/nt_cld.png'
import part_sun from '/@/assets/images/weather/part_sun.png'
import sunny from '/@/assets/images/weather/sunny.png'
import nt_part from '/@/assets/images/weather/nt_part.png'
import nt_star from '/@/assets/images/weather/nt_star.png'
import thunder from '/@/assets/images/weather/thunder.png'
import lt_rain from '/@/assets/images/weather/lt_rain.png'
import md_rain from '/@/assets/images/weather/md_rain.png'
import hvy_rain from '/@/assets/images/weather/hvy_rain.png'
import drp_rain from '/@/assets/images/weather/drp_rain.png'
import tor_rain from '/@/assets/images/weather/tor_rain.png'
import snow from '/@/assets/images/weather/snow.png'
import lt_snow from '/@/assets/images/weather/lt_snow.png'
import md_snow from '/@/assets/images/weather/md_snow.png'
import hvy_snow from '/@/assets/images/weather/hvy_snow.png'
import bliz from '/@/assets/images/weather/bliz.png'
import snw_strm from '/@/assets/images/weather/snw_strm.png'
import windy from '/@/assets/images/weather/windy.png'
import windy_snw from '/@/assets/images/weather/windy_snw.png'
import rainbow from '/@/assets/images/weather/rainbow.png'
import tornado from '/@/assets/images/weather/tornado.png'
import low_tmp from '/@/assets/images/weather/low_tmp.png'
import high_tmp from '/@/assets/images/weather/high_tmp.png'
import cloudy from '/@/assets/images/weather/cloudy.png'
import thdr from '/@/assets/images/weather/thdr.png'
import sleet from '/@/assets/images/weather/sleet.png'
import typhoon from '/@/assets/images/weather/typhoon.png'
import fog from '/@/assets/images/weather/fog.png'
import frost from '/@/assets/images/weather/frost.png'
import sunrise from '/@/assets/images/weather/sunrise.png'
import nt_windy from '/@/assets/images/weather/nt_windy.png'
import cld_windy from '/@/assets/images/weather/cld_windy.png'
import dust from '/@/assets/images/weather/dust.png'
import n_a from '/@/assets/images/weather/n_a.png'
import rain from '/@/assets/images/weather/rain.png'
export enum ERouterName {
    TEST = 'test',
    ELEMENT = 'element',
    PROJECT = 'project',
    SCENARIO = 'scenario',
    SCENARIO_NAME = '电子沙盘',
    SCENARIO_WORKSPACE = 'scenario-workspace',
    SCENARIO_WORKSPACE_NAME = '电子沙盘',
    SCENARIO_PLAN = 'scenario-plan',
    SCENARIO_PLAN_NAME = '场景预案',
    SCENARIO_ICON = 'scenario-icon',
    SCENARIO_ICON_NAME = '图标库',
    HOME = 'home',
    TSA = 'tsa',
    TSA_NAME = '首页',
    LAYER = 'layer',
    LAYER_NAME = '地图模型',
    MEDIA = 'media',
    MEDIA_NAME = '媒体成果',
    WAYLINE = 'wayline',
    WAYLINE_NAME = '航线库',
    LIVESTREAM = 'livestream',
    LIVESTREAM_NAME = '视频墙',
    LIVING = 'living',
    WORKSPACE = 'workspace',
    WORKSPACE_NAME = '指挥台',
    SYSTEM = '',
    SYSTEM_NAME = '系统管理',
    MEMBERS = 'members',
    MEMBERS_NAME = '员工管理',
    DEVICES = 'devices',
    DEVICES_NAME = '设备管理',
    DICT = 'dict',
    DICT_NAME = '字典管理',
    MENU = 'menu',
    MENU_NAME = '菜单管理',
    ROLE = 'role',
    ROLE_NAME = '角色管理',
    TASK = 'task',
    TASK_NAME = '计划库',
    CREATE_PLAN = 'create-plan',
    CREATE_PLAN_NAME = '创建计划',
    CREATE_FLIGHT_PLAN = 'create-flight-plan',
    CREATE_FLIGHT_PLAN_NAME = '创建飞行计划',
    SELECT_PLAN = 'select-plan',
    SELECTS_PLAN = 'selects-plan',
    FIRMWARES = 'firmwares',
    FIRMWARES_NAME = '固件管理',
    FLIGHT_AREA = 'flight-area',
    FLIGHT_AREA_NAME = '空域安全',
    PILOT = 'pilot-login',
    PILOT_HOME = 'pilot-home',
    PILOT_MEDIA = 'pilot-media',
    PILOT_LIVESHARE = 'pilot-liveshare',
    PILOT_BIND = 'pilot-bind',
    USER = 'user',
    USER_NAME = '个人中心',
    ORG = 'org',
    ORG_NAME = '组织列表',
    ALG = 'alg',
    ALG_NAME = '算法库',
    ALARM = 'alarm',
    ALARM_NAME = '告警库',
    INDIVIDUAL_TASK = 'individual-task',
    INDIVIDUAL_TASK_NAME = '单兵任务',
    FLY_CONTROL_NAME = '飞行控制',
    FLY_CONTROL = 'flyControl',
    DRONE_CONTROL='droneControl',
    FLIGHT_REPORT = 'flight-notification-approval',
    FLIGHT_REPORT_NAME = '飞行报备',
    ALARM_DISPOSITION = 'alarm-disposition',
    DRIVER_NAME = '驾驶舱',
    DRIVER = 'drivce',
    INST_LOG_NAME = '指令日志',
    INST_LOG = 'instructionLog',
    DATA_UI = 'dataUi',
    DATA_UI_NAME = '数据看板',
    FLIGHT_TRAJECTORY = 'flightTrajectory',
    FLIGHT_TRAJECTORY_NAME = '飞行轨迹',
    THREE = 'three',
    THREE_NAME = '全景测试',
    FLIGHT_PLAN = 'flightPlan',
    FLIGHT_PLAN_NAME = '飞行申请',
    REPORT_NAME = '报告库',
    REPORT = 'report',
    MEGAPHONE = 'megaphone',
    DRONE_MEGAPHONE = 'droneMegaphone',
    REAL_TIME_SHOUT = 'realTimeShout',
    SEARCHLIGHT = 'searchlight'
}

export enum EStorageKey {
    LANG_CODE = 'DJI_CREATE_VITE_H5_APP:lang_code',
    TEST_TOOLS_POSITION_STORAGE_KEY = 'DJI_CREATE_VITE_H5_APP:test_tools_position',
    SESSION_ID = 'DJI_CREATE_VITE_H5_APP:sess'
}

export enum EStatusValue {
    CONNECTED = 'Connected',
    DISCONNECT = 'Disconnect',
    LIVING = 'Living'
}

export enum ELiveStatusValue {
    DISCONNECT,
    CONNECTED,
    LIVING
}

export enum EComponentName {
    Thing = 'thing',
    Liveshare = 'liveshare',
    Api = 'api',
    Ws = 'ws',
    Map = 'map',
    Tsa = 'tsa',
    Media = 'media',
    Mission = 'mission'
}

export enum ELocalStorageKey {
    LoginName = 'login_name',
    Username = 'username',
    WorkspaceId = 'workspace_id',
    Token = 'x-auth-token',
    XJToken = 'authorization',
    PlatformName = 'platform_name',
    WorkspaceName = 'workspace_name',
    WorkspaceDesc = 'workspace_desc',
    Flag = 'flag',
    UserId = 'user_id',
    Device = 'device',
    GatewayOnline = 'gateway_online',
    UserRoleId = 'user_role_id',
    IsPilot = 'is_pilot', // 飞手资质
}

export enum SystemTitleKey {
    SystemTitle = 'system_title',
    Agora_Token = 'agora_token'
}

export enum ScreenTitleKey {
    ScreenTitle = 'screen_title',
    SystemTitle = 'SystemTitle'
}

export enum loginCopyrightTitleKey {
    loginCopyrightTitle = 'login_copyright',
}

export enum EPhotoType {
    Original = 0,
    Preview = 1,
    Unknown = -1
}

export enum EDownloadOwner {
    Mine = 0,
    Others = 1,
    Unknown = -1
}

export enum EUserType {
    Web = 1,
    Pilot = 2,
}

export enum EBizCode {
    GatewayOsd = 'gateway_osd',
    DeviceOsd = 'device_osd',
    DockOsd = 'dock_osd',
    MapElementCreate = 'map_element_create',
    MapElementUpdate = 'map_element_update',
    MapElementDelete = 'map_element_delete',
    DeviceOnline = 'device_online',
    DeviceOffline = 'device_offline',
    DeviceHms = 'device_hms',

    // 机场任务
    FlightTaskProgress = 'flighttask_progress', // 机场任务执行进度
    FlightTaskMediaProgress = 'file_upload_callback', // 机场任务媒体上传进度
    FlightTaskMediaHighestPriority = 'highest_priority_upload_flighttask_media', // 机场任务媒体优先级上报

    // 设备指令
    DeviceReboot = 'device_reboot', // 机场重启
    DroneOpen = 'drone_open', // 飞行器开机
    DroneClose = 'drone_close', // 飞行器关机
    DeviceFormat = 'device_format', // 机场数据格式化
    DroneFormat = 'drone_format', // 飞行器数据格式化
    CoverOpen = 'cover_open', // 打开舱盖
    CoverClose = 'cover_close', // 关闭舱盖
    PutterOpen = 'putter_open', // 推杆展开
    PutterClose = 'putter_close', // 推杆闭合
    ChargeOpen = 'charge_open', // 打开充电
    ChargeClose = 'charge_close', // 关闭充电

    // 设备升级
    DeviceUpgrade = 'ota_progress', // 设备升级

    // 设备日志
    DeviceLogUploadProgress = 'fileupload_progress', // 设备日志上传

    // 飞行指令消息
    ControlSourceChange = 'control_source_change', // 控制权更新
    FlyToPointProgress = 'fly_to_point_progress', // 飞向目标点(flyto 执行结果事件通知)
    TakeoffToPointProgress = 'takeoff_to_point_progress', // 一键起飞(一键起飞结果事件通知)
    JoystickInvalidNotify = 'joystick_invalid_notify', // 设备端退出drc模式(DRC-飞行控制无效原因通知){"0":"遥控器失联","1":"低电量返航","2":"低电量降落","3":"靠近限飞区","4":"遥控器夺权（例如：触发了返航，B控夺权）"}
    DrcStatusNotify = 'drc_status_notify', // DRC 链路状态通知（已废弃）

    // 自定义飞行区域
    FlightAreasSyncProgress = 'flight_areas_sync_progress', // 自定义飞行区文件同步状态
    FlightAreasDroneLocation = 'flight_areas_drone_location', // 自定义飞行区告警信息推送
    FlightAreasUpdate = 'flight_areas_update', // 自定义飞行区更新指令
    FlightAreasGet = 'flight_areas_get', // 自定义飞行区文件获取
}

export enum EDeviceTypeName {
    Aircraft = 0, // 飞行器
    Payload = 1, // 机载载荷设备
    Gateway = 2, // 网关
    Dock = 3, // 机场
}

export const EDeviceTypeNameMap = {
  [EDeviceTypeName.Aircraft]: '飞行器',
  [EDeviceTypeName.Payload]: '机载载荷设备',
  [EDeviceTypeName.Gateway]: '网关',
  [EDeviceTypeName.Dock]: '机场'
}

export enum EAlgTypeName {
    Algo = 0, // 算法
    Aerocraft = 1 // 飞行器
}

export const EAlgTypeNameMap = {
  [EAlgTypeName.Algo]: '算法',
  [EAlgTypeName.Aerocraft]: '飞行器'
}

export enum EHmsLevel {
    NOTICE, // 注意
    CAUTION, // 警告
    WARN, // 警告
}

export const EHmsLevelMap = {
  [EHmsLevel.NOTICE]: '注意',
  [EHmsLevel.CAUTION]: '警告',
  [EHmsLevel.WARN]: '警告'
}
export const weatherImg = {
  多云伴日出: sun_rise,
  夜间多云伴月亮: nt_cld,
  小晴天: part_sun,
  晴朗: sunny,
  夜间多云: nt_part,
  夜间晴: nt_star,
  雷阵雨: thunder,
  雷小雨: lt_rain,
  雷中雨: md_rain,
  雷大雨: hvy_rain,
  雷暴雨: drp_rain,
  雷大暴雨: tor_rain,
  下雪: snow,
  小雪: lt_snow,
  多云带雪: md_snow,
  中雪: hvy_snow,
  大雪: bliz,
  暴雪: snw_strm,
  大风: windy,
  风雪: windy_snw,
  彩虹: rainbow,
  龙卷风: tornado,
  低温: low_tmp,
  高温: high_tmp,
  多云: cloudy,
  雷雨: thdr,
  中雨: sleet,
  台风: typhoon,
  雾霾: fog,
  霜冻: frost,
  日出: sunrise,
  夜间大风: nt_windy,
  狂风: cld_windy,
  沙尘: dust,
  无: n_a,
  雨: rain
}
